// Ф3 (23.08.2026) — „какво ново има от последното ми отваряне" за публичния линк.
//
// Геодезистът искаше известие на иконата на телефона. Истинското известие иска
// разрешение от телефона, ключове и таблица с абонаменти (и на iPhone работи
// само от iOS 16.4 нагоре). Той избра простия вариант: без известие, но при
// отваряне на линка се вижда кои землища са се появили или изчезнали.
//
// Затова тук няма сървър — състоянието „видяно" стои в самото устройство.
// Следствието, което трябва да се знае: два телефона броят поотделно, а
// изчистването на данните на браузъра нулира отправната точка.
//
// Следи се САМО съставът на списъка (кои землища го има), не и числата в тях —
// изрично: „бъркаме ли числа или замени, не трябва да се буди".

const KEY = (token) => `p4-seen-${token}`;

// Ц1: един линк може да покрива няколко фирми и всяка има свой списък землища.
// Ключът на ОСНОВНАТА фирма си остава чистата година — иначе всички, които вече
// ползват линка, биха видели целия си списък като „ново" в деня на промяната.
// Добавените фирми вървят с представка `булстат:`.
export const scopeKey = (year, bullstat, primaryBullstat) =>
    (bullstat == null || String(bullstat) === String(primaryBullstat))
        ? String(year)
        : `${bullstat}:${year}`;

// {"2026": [{ekatte, name}], "2025": [...], "204977764:2026": [...]}
export const readSeen = (token) => {
    try {
        return JSON.parse(localStorage.getItem(KEY(token))) || {};
    } catch (e) {
        return {};
    }
};

export const writeSeen = (token, year, settlements, key = null) => {
    const всичко = readSeen(token);
    всичко[key || String(year)] = (settlements || []).map(s => ({ekatte: s.ekatte, name: s.name}));
    try {
        localStorage.setItem(KEY(token), JSON.stringify(всичко));
    } catch (e) {
        // Частен режим/пълна памет — тогава просто няма да помни. Не е повод
        // страницата да спре да работи.
    }
    return всичко;
};

// Какво се е променило спрямо запомненото. Сравнява се по ЕКАТТЕ, не по име:
// преименувано землище не е ново землище.
export const diffSettlements = (seen, current) => {
    const беше = new Set((seen || []).map(s => s.ekatte));
    const сега = new Set((current || []).map(s => s.ekatte));
    return {
        added: (current || []).filter(s => !беше.has(s.ekatte)),
        removed: (seen || []).filter(s => !сега.has(s.ekatte)),
    };
};

// Отправната точка за една година. `undefined` значи, че тази година се отваря
// за първи път на това устройство — тогава НЕ се обявява нищо за ново, защото
// иначе при първото влизане светва целият списък.
export const baselineFor = (seen, year, key = null) => (seen || {})[key || String(year)];

// Ъ8 — съобщенията и добавените справки с отметка „Известяване".
//
// За разлика от землищата, тук ПЪРВОТО отваряне не се запомня тихо: съобщение,
// което човекът никога не е виждал, е точно това, което лентата трябва да му
// покаже. Помни се по ключ на елемента — `m<id>` за съобщение и `r<seen_key>`
// за справка (в seen_key влиза и моментът на добавяне, тоест махната и добавена
// наново справка е нова).
const NOTICE_KEY = (token) => `p4-notices-${token}`;

export const readNotices = (token) => {
    try {
        const v = JSON.parse(localStorage.getItem(NOTICE_KEY(token)));
        return Array.isArray(v) ? v : [];
    } catch (e) {
        return [];
    }
};

export const markNoticesSeen = (token, keys) => {
    const всички = new Set([...readNotices(token), ...(keys || [])]);
    try {
        localStorage.setItem(NOTICE_KEY(token), JSON.stringify([...всички]));
    } catch (e) {
        // частен режим / пълна памет — просто няма да помни
    }
    return [...всички];
};

// Кои неща с отметка „Известяване" още не са видени на това устройство.
export const unseenNotices = (seenKeys, messages, reports) => {
    const видени = new Set(seenKeys || []);
    return [
        ...(messages || []).filter(m => m.notify)
            .map(m => ({kind: 'message', key: `m${m.id}`, item: m})),
        ...(reports || []).filter(r => r.notify)
            .map(r => ({kind: 'report', key: `r${r.seen_key}`, item: r})),
    ].filter(n => !видени.has(n.key));
};
